import * as React from 'react';

const SvgMoneyMini = (props) => (
  <svg
    width={32}
    height={32}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M25.56 8.853c-.573-2.893-2.72-4.16-5.706-4.16H8.147c-3.52 0-5.867 1.76-5.867 5.867v6.867c0 2.96 1.214 4.693 3.214 5.44.293.106.613.2.946.253.534.12 1.107.173 1.707.173h11.72c3.52 0 5.867-1.76 5.867-5.866V10.56c0-.627-.054-1.187-.174-1.707ZM7.374 16c0 .547-.454 1-1 1-.547 0-1-.453-1-1v-4c0-.547.453-1 1-1 .546 0 1 .453 1 1v4ZM14 17.52A3.517 3.517 0 0 1 10.48 14 3.517 3.517 0 0 1 14 10.48 3.517 3.517 0 0 1 17.52 14 3.517 3.517 0 0 1 14 17.52ZM22.614 16c0 .547-.454 1-1 1-.547 0-1-.453-1-1v-4c0-.547.453-1 1-1 .546 0 1 .453 1 1v4Z'
      fill='#E00034'
    />
    <path
      d='M29.733 14.56v6.867c0 4.106-2.347 5.88-5.88 5.88H12.146c-1 0-1.893-.147-2.666-.44a4.496 4.496 0 0 1-1.614-.987c-.24-.227-.053-.587.28-.587h11.707c4.933 0 7.867-2.933 7.867-7.853v-6.88c0-.32.36-.52.586-.28.907.96 1.427 2.36 1.427 4.28Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgMoneyMini;
